import React from 'react';
import PropTypes from 'prop-types';

import styles from './common-button.css';

const Button = (props) => {
    const { children, onClick, modifier, type, arrow, brand, alternateColor, href, disabled, ...other } = props;

    const classList = `${styles.button}
                       ${arrow ? styles['button--arrow'] : ''}
                       ${alternateColor ? styles['button--alternate-color'] : ''}
                       ${disabled ? styles['button--disabled'] : ''}
                       ${brand ? styles[`button--${brand}`] : ''}
                       ${modifier || ''}`;

    if (href) {
        return (
            <a
                className={classList}
                {...{
                    onClick,
                    type,
                    href,
                    ...other
                }}
                disabled={disabled}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            className={classList}
            {...{
                onClick,
                type,
                ...other
            }}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    modifier: PropTypes.string,
    type: PropTypes.string,
    arrow: PropTypes.bool,
    alternateColor: PropTypes.bool
};

Button.defaultProps = {
    arrow: false,
    alternateColor: false
};

export default Button;

